export function getExceptionScheduleLink({
  standard_id,
  usage_id,
  session_event_type,
}: {
  standard_id: string;
  usage_id: string;
  session_event_type: string;
}) {
  const adult_adhd_event_type =
    "https://api.calendly.com/event_types/4256dd81-1fbd-4f51-b569-5f1350c3aed6";
  const child_adhd_event_type =
    "https://api.calendly.com/event_types/05a20f65-5cd0-4dff-85b3-71faba81ed24";

  return standard_id === "1388d1f3-fff0-4a5c-9fe9-51c82baf09de" 
    // standard_id === "2fc607a3-32eb-4b2c-bf0d-9c3ac3c46e09"
    ? `https://www.rockethealth.app/schedule/cancer-care?usage_id=${usage_id}&exception=true`
    : standard_id === "202844fa-9add-4ea4-9e1b-0db98212ac80" ||
      standard_id === "256e4218-6566-4e43-a33d-46db1de00436"
    ? `https://www.rockethealth.app/schedule/personality-disorder?usage_id=${usage_id}&exception=true`
    : standard_id === "526204b4-8ce6-4a41-b423-87455b4e1bed" ||
      standard_id === "ac61f142-021a-4cde-b380-98cb0aaee743"
    ? `https://www.rockethealth.app/schedule/session-with-your-psychiatrist?usage_id=${usage_id}&exception=true`
    : (standard_id === "ecd5a752-7c2c-4d0e-8285-539f41766891" ||
        standard_id === "256e4218-6566-4e43-a33d-46db1de00436") &&
      session_event_type === adult_adhd_event_type
    ? `https://www.rockethealth.app/schedule/adhd?usage_id=${usage_id}&exception=true`
    : (standard_id === "ecd5a752-7c2c-4d0e-8285-539f41766891" ||
        standard_id === "256e4218-6566-4e43-a33d-46db1de00436") &&
      session_event_type === child_adhd_event_type
    ? `https://www.rockethealth.app/schedule/child-adhd?usage_id=${usage_id}&exception=true`
    : standard_id === "3e721192-d1a9-4291-aef4-9850cf6ac1f3" ||
      standard_id === "eb9abe05-370a-452c-8672-b55aedd0c5fa"
    ? `https://www.rockethealth.app/schedule/session-with-your-psychiatrist?usage_id=${usage_id}&exception=true`
    : standard_id === "5cc0a93b-f836-4f41-8b23-197d997751f5" ||
      standard_id === "256e4218-6566-4e43-a33d-46db1de00436"
    ? `https://www.rockethealth.app/schedule/clinical-psychologist?usage_id=${usage_id}&exception=true`
    : standard_id === "0da18a28-3acb-4a3f-a8ac-8813610cec35" ||
      standard_id === "97d1bccb-f9e2-4bb3-8d6c-badaa798fed7" ||
      standard_id === "b56b5a7c-e309-493b-a9f7-02a06e202b6e"
    ? `https://www.rockethealth.app/schedule/session-with-your-clinical-psychologist?usage_id=${usage_id}&exception=true`
    : standard_id === "34a7f4d5-37ca-4fc5-8aca-e0749a8b1206" ||
      standard_id === "d5da9b79-a28a-416e-b063-d42808ae8f18" ||
      standard_id === "17a3e333-f18c-4bf9-b0aa-632ba5452a41"
    ? `https://www.rockethealth.app/schedule/therapy?usage_id=${usage_id}&exception=true`
    : standard_id === "0a24259b-aee9-4c74-bb1a-7d731f914bc0" ||
      standard_id === "4e49b757-4a40-4fc2-822a-0ddd790b8086" ||
      standard_id === "702c5693-47fe-4e2e-b31a-7f2993610176" ||
      standard_id === "0cf5d0a6-b488-44dc-b501-a2166e4a3458" ||
      standard_id === "2fc607a3-32eb-4b2c-bf0d-9c3ac3c46e09" 
    ? `https://www.rockethealth.app/schedule/session-with-your-psychologist?usage_id=${usage_id}&exception=true`
    : standard_id === "0d08a27d-3824-41ce-8d5d-67aecc9745fe" ||
      standard_id === "5c9b311d-c6ff-432e-aea2-055ed56df111" ||
      standard_id === "b641ef79-0f20-4eea-8cc6-3827a4de6150"
    ? `https://www.rockethealth.app/schedule/session-with-your-psychologist-gift-eng?usage_id=${usage_id}&exception=true`
    : ``;
}
